









































































import Vue from 'vue'
import Component from 'vue-class-component'
import Icon from '@/components/Icon.vue'
import RadioGroup from '@/components/RadioGroup.vue'
import Input from '@/components/inputs/Input.vue'
import ErrorMessages from '@/components/ErrorMessages.vue'
import Select from '@/components/Select.vue'
import Address from './Address.vue'
import {
  EPaymentReceiptType,
  IResidentContact
} from '@zunta/configurations'
import { EMAIL_REGEX } from '@/constants'

@Component({
  props: {
    withPrint: {
      type: Boolean,
      default: true
    },
    withSkip: {
      type: Boolean,
      default: false
    },
    defaultMode: {
      type: String,
      default: undefined
    },
    selectFullName: {
      type: Boolean,
      default: true
    }
  },
  components: {
    Address,
    Icon,
    RadioGroup,
    Input,
    Select,
    ErrorMessages
  }
})
export default class Addresses extends Vue {
  mode: EPaymentReceiptType = this.$props.defaultMode ? this.$props.defaultMode : EPaymentReceiptType.PRINT_RECEIPT
  addMode: EPaymentReceiptType | null = null
  addressForm: any = {}
  emailForm: any = {}
  selectedAddress: number = 0
  addEmailErrors: string[] = []
  tempContacts: Partial<IResidentContact>[] = []
  EPaymentReceiptType: any = EPaymentReceiptType

  mounted () {
    const selected = {
      receiptType: this.mode,
      receiptAddress: 'print',
      receiptName: 'print'
    }
    this.$emit('select', selected)
  }

  get residentContacts () {
    return this.$store.state.resident.residentContacts
  }

  get receiptTypeListItems () {
    const items: any = []
    if (this.$props.withSkip) {
      items.push({
        content: this.getPaymentRecieptLabel(EPaymentReceiptType.PRINT),
        key: EPaymentReceiptType.PRINT,
        value: EPaymentReceiptType.PRINT
      })
    }
    if (this.$props.withPrint) {
      items.push({
        content: this.getPaymentRecieptLabel(EPaymentReceiptType.PRINT_RECEIPT),
        key: EPaymentReceiptType.PRINT_RECEIPT,
        value: EPaymentReceiptType.PRINT_RECEIPT
      })
    }
    items.push({
      content: this.getPaymentRecieptLabel(EPaymentReceiptType.EMAIL),
      key: EPaymentReceiptType.EMAIL,
      value: EPaymentReceiptType.EMAIL
    })
    return items
  }

  getPaymentRecieptLabel (receiptType: EPaymentReceiptType) {
    const RECEIPT_TYPE_LABLE_MAP: any = {
      [EPaymentReceiptType.EMAIL]: 'Email',
      [EPaymentReceiptType.ADDRESS]: 'Address',
      [EPaymentReceiptType.PRINT]: 'No Receipt',
      [EPaymentReceiptType.PRINT_RECEIPT]: 'Print Receipt'
    }
    return RECEIPT_TYPE_LABLE_MAP[receiptType]
  }

  get getContacts () {
    if (this.mode === EPaymentReceiptType.EMAIL) {
      return this.residentContacts.concat(this.tempContacts).filter((contact: IResidentContact) => !!contact.email)
    }
    return []
  }

  changeMode (mode: EPaymentReceiptType) {
    this.mode = mode
    this.addMode = null
    let selected = null
    switch (this.mode) {
      default:
      case EPaymentReceiptType.PRINT:
        selected = {
          receiptType: this.mode,
          receiptAddress: 'print',
          receiptName: 'print'
        }
        break
      case EPaymentReceiptType.PRINT_RECEIPT:
        selected = {
          receiptType: this.mode,
          receiptAddress: 'print_receipt',
          receiptName: 'print_receipt'
        }
        break
      case EPaymentReceiptType.EMAIL:
        selected = {
          receiptType: this.mode,
          receiptAddress: '',
          receiptName: ''
        }
        break
    }
    this.$emit('select', selected)
  }

  cancel () {
    this.addMode = null
  }

  validateAddEmail () {
    const requiredFieldsErrorsMap: any = {
      email: 'Email is Required',
      firstName: 'First Name is Required'
    }
    if (this.$props.selectFullName) {
      requiredFieldsErrorsMap.lastName = 'Last Name is Required'
    }

    this.addEmailErrors = []
    Object.keys(requiredFieldsErrorsMap).forEach((fieldName: string) => {
      if (!this.emailForm[fieldName]) {
        this.addEmailErrors.push(requiredFieldsErrorsMap[fieldName])
      }
      // @ts-ignore
      const regex = EMAIL_REGEX
      if (fieldName === 'email' && !regex.test(this.emailForm.email)) {
        this.addEmailErrors.push('This is not a valid email address.')
      }
    })
    return this.addEmailErrors.length === 0
  }

  saveEmail () {
    if (this.validateAddEmail()) {
      this.addTempContacts({
        ...this.emailForm
      })
      this.emailForm = {}
      this.addMode = null
    }
  }

  addTempContacts (contactData: Partial<IResidentContact>) {
    const maxId = Math.max.apply(Math, this.residentContacts.concat(this.tempContacts).map((contact: IResidentContact) => contact.id))
    const tempContact = {
      ...contactData,
      id: maxId + 1
    }
    this.tempContacts.push(tempContact)
    this.selectContact(tempContact)
  }

  selectContact (contact: Partial<IResidentContact>) {
    this.selectedAddress = contact.id as number
    if (this.mode === EPaymentReceiptType.ADDRESS) {
      this.$emit('select', {
        receiptName: this.$props.selectFullName ? `${contact.firstName} ${contact.lastName}` : contact.firstName,
        receiptType: this.mode,
        receiptAddress: `${contact.addressLine1} ${contact.addressLine2} ${contact.city} ${contact.state} ${contact.zipCode}`,
        ...contact,
        receiptState: contact.state,
        receiptCity: contact.city,
        receiptAddressLine1: contact.addressLine1,
        receiptAddressLine2: contact.addressLine2,
        receiptZip: contact.zipCode,
        zip: contact.zipCode
      })
    } else if (this.mode === EPaymentReceiptType.EMAIL) {
      this.$emit('select', {
        receiptName: this.$props.selectFullName ? `${contact.firstName} ${contact.lastName}` : contact.firstName,
        receiptType: this.mode,
        receiptAddress: `${contact.email}`
      })
    }
  }
}
